export default __webpack_public_path__ + "static/media/Member_Filled.0f78ed69.svg";